var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.274 25.406a.933.933 0 1 0 1.32 1.32l3.132-3.132a.93.93 0 0 0 0-1.32.933.933 0 0 0-1.32 0z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.244 25.733a.742.742 0 1 0 1.05 1.05l2.489-2.49a.74.74 0 0 0 0-1.05.742.742 0 0 0-1.05 0zM5.217 21.707a.742.742 0 1 0 1.05 1.05l2.49-2.49a.74.74 0 0 0 0-1.05.742.742 0 0 0-1.05 0z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.217 15.927c.114.033.218.077.319.127a17.997 17.997 0 0 1 2.739-4.976 4.376 4.376 0 0 0-1.876.023c-1.948.444-3.744 2.117-5.34 4.973A.446.446 0 0 0 5 16.3c0 .119.05.238.138.33.15.142.375.17.554.064.564-.335 2.292-1.123 3.525-.766zM15.927 26.942c4.203-2.347 5.087-4.744 5.087-6.34a4.28 4.28 0 0 0-.09-.877 18 18 0 0 1-4.978 2.74c.144.29.219.626.219 1.02 0 1.353-.848 2.81-.857 2.824a.464.464 0 0 0 .064.555.465.465 0 0 0 .555.078z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.088 11.159c.101.601.101 1.23 0 1.832a5.532 5.532 0 0 1 1.831 0 5.534 5.534 0 0 1 0-1.833 5.532 5.532 0 0 1-1.831 0z"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M27 5.458c0 7.756-5.239 14.577-12.742 16.575a.44.44 0 0 1-.44-.12l-3.731-3.73a.437.437 0 0 1-.12-.44C11.968 10.239 18.788 5 26.543 5a.46.46 0 0 1 .458.458zm-4.442 4.229a4.51 4.51 0 0 0-.002 4.774c.065.102-.055.222-.166.167a4.51 4.51 0 0 0-4.774 0c-.056.038-.111.02-.148-.018s-.056-.092-.018-.148a4.51 4.51 0 0 0 0-4.774c-.064-.12.056-.24.167-.166a4.51 4.51 0 0 0 4.774-.001c.056-.037.111-.019.148.018s.055.093.018.148z",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/Rocket.62810c2a8d28560b377589f0ebf8320a.svg";
export { ForwardRef as ReactComponent };